/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unarchiveconfirmmessage2Inputs */



/**
* | output |
* | --- |
* | "The contact will return to the main page of the “Chats” section." |
*
* @param {Unarchiveconfirmmessage2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const unarchiveconfirmmessage2 = /** @type {((inputs?: Unarchiveconfirmmessage2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unarchiveconfirmmessage2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The contact will return to the main page of the “Chats” section.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El contacto volverá a la página principal de la sección «Chats».")
	return /** @type {LocalizedString} */ ("Контакт вернется на главную страницу раздела “Чаты”.")
});
export { unarchiveconfirmmessage2 as "unarchiveConfirmMessage" }